import * as React from 'react';
import isBrowser from 'services/isBrowser';

export const useElementWidth = (ref: any, handler: (width: number) => void) => {
    let resizeTimeout: any = null;
    const onResize = () => {
        if (resizeTimeout) {
            clearTimeout(resizeTimeout);
        }

        resizeTimeout = setTimeout(() => {
            if (ref?.current) {
                let width = ref.current.offsetWidth;
                if (isBrowser()) {
                    width = Math.min(window.innerWidth - 16, width)
                }
                handler(width);
            }
        }, 20)

    }
    React.useEffect(() => {
        if (ref?.current) {
            onResize();
        }
        if (!isBrowser()) return;
        window.addEventListener('resize', onResize)
        return () => window.removeEventListener('resize', onResize)
    })
}